import {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash"
import {Empty, Modal, notification} from "antd";
import
{
	Button,
	Loading,
	Icon
} from "~/components";
import ActionBar from "~/layout/ActionBar";
import
{
	handleRequest,
	apiError,
} from "~/utils";
import
{
	useCan
} from "~/hooks";
import
{
	customerApi
} from "~/api";
import {
	CustomerSearchBar,
	CustomerTable,
	CustomerFormAddEdit,
} from "../components";
import {
	customerActions,
	customerErrorSelector,
	customerFilterSelector,
	customerItemsSelector,
	customerLoadingSelector,
	customerPaginationSelector
} from "../../../reduxs/Customer/customerSlice";


function Customer()
{
	const can = {
	    add : useCan('customer_add'),
	    edit : useCan('customer_edit'),
	    delete : useCan('customer_delete')
	}

	const dispatch  = useDispatch();

	const items     = useSelector(customerItemsSelector);

	const loading   = useSelector(customerLoadingSelector);

	const error     = useSelector(customerErrorSelector);

	const pagination = useSelector(customerPaginationSelector);

	const filter    = useSelector(customerFilterSelector);

	const [itemEdit, setItemEdit] = useState({});

	//Model
	const [openModal, setOpenModal] = useState({
		addEdit     : false,
		delete      : false,
	});

	const eventHandlers =
	{
		openModal : useCallback((modal) =>
		{
			setOpenModal(prev => ({ ...prev, [modal]: true }));
		}, []),

		closeModal : useCallback((modal) =>
		{
			setOpenModal(prev => ({ ...prev, [modal]: false }));
		}, []),

		load: useCallback(() =>
		{
			dispatch(customerActions.fetchData(filter));
		}, [dispatch, filter]),

		paginationChange: (page) =>
		{
			dispatch(customerActions.setFilter({...filter, page }));
		},

		search: (newFilter) =>
		{
			dispatch(customerActions.setFilterWithDebounce(newFilter));
		},

		filterChange: (key, value) =>
		{
			const newFilter = {
				...filter,
				[key]: value,
				page: 1
			};
			dispatch(customerActions.setFilter(newFilter));
		},

		add: async (data) =>
		{
			let [error, response] = await handleRequest(customerApi.add(data));

			let message = apiError(`Thêm khách hàng thất bại`, error, response);

			if(!message)
			{
				notification.success({message: 'Thành công', description: `Thêm khách hàng thành công`});

				dispatch(customerActions.add(response.data));

				eventHandlers.closeModal('addEdit')
			}
		},

		update: async (data, item) =>
		{
			if (!item?.id)
			{
				notification.error({message: 'Lỗi', description: 'Không có thông tin khách hàng để cập nhật'});
				return;
			}

			data.id = item.id;

			let [error, response] = await handleRequest(customerApi.update(data));

			if(!apiError(`Cập nhật thông tin khách hàng thất bại`, error, response))
			{
				notification.success({message: 'Thành công', description: `Cập nhật thông tin khách hàng thành công`});

				dispatch(customerActions.update({
					...item,
					...response.data
				}));

				eventHandlers.closeModal('addEdit')
			}
		},

		//Delete
		delete: async () =>
		{
			if (!itemEdit?.id)
			{
				notification.error({message: 'Lỗi', description: 'Không có thông tin khách hàng để xóa'});
				return;
			}

			let [error, response] = await handleRequest(customerApi.delete(itemEdit.id));

			if(!apiError(`xóa khách hàng thất bại`, error, response))
			{
				notification.success({message: 'Thành công', description: `xóa khách hàng thành công`});

				dispatch(customerActions.delete(itemEdit.id));

				eventHandlers.closeModal('delete')
			}
		}
	}

	//Load data
	useEffect(() =>
	{
		let isMounted = true;
		if (isMounted) eventHandlers.load();
		return () => { isMounted = false };
	}, [filter]);

	return (
		<>
			<ActionBar title={'Khách Hàng'}>
				{can.add && <Button outline leftIcon={Icon.plusCircle} onClick={() => {setItemEdit({}); eventHandlers.openModal('addEdit')}}>Thêm mới</Button>}
				<Button outline onClick={eventHandlers.load}>{Icon.reload}</Button>
			</ActionBar>
			<div className="container">
				<div className="content p-2">
					{loading && <Loading/>}
					{<CustomerSearchBar filter={filter} onSearchChange={eventHandlers.search} onChange={eventHandlers.filterChange} can={can} />}
					{_.isEmpty(items) && <Empty />}
					{!_.isEmpty(items) && <CustomerTable
							items={items}
							pagination={pagination}
							onPaginationChange={eventHandlers.paginationChange}
							setItemEdit={setItemEdit}
							openModal={eventHandlers.openModal}
							can={can}
					/>}
				</div>
				{
					(can.add || can.edit) && <Modal
						title="Khách hàng"
						centered
						width={1000}
						open={openModal.addEdit}
						onCancel={() => {eventHandlers.closeModal('addEdit')}}
						footer={null}
					>
						<CustomerFormAddEdit item={itemEdit}
											 onAdd={eventHandlers.add}
											 onUpdate={eventHandlers.update}
						/>
					</Modal>
				}
				{
					(can.delete && itemEdit?.id) && <Modal
						title="Xóa khách hàng"
						open={openModal.delete}
						onOk={eventHandlers.delete}
						okType={'danger'}
						onCancel={() => {eventHandlers.closeModal('delete')}
					}>
						<p>Bạn muốn xóa khách hàng <b>{itemEdit?.name}</b>?</p>
					</Modal>
				}
			</div>
		</>
	)
}

export default Customer;